import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'woo-modal-layout',
  imports: [],
  templateUrl: './modal-layout.component.html',
  styleUrl: './modal-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalLayoutComponent {
  size = input<'small' | 'medium' | 'large'>('small');
  closable = input<boolean>(true);
  close = output<boolean>();
  centerTitle = input<boolean>(false);
}
